function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classNames from 'classnames';
import { IconRightOutlined, IconLeftOutlined } from '@osui/icons';
import { useBrandContext } from '@osui/brand-provider';
import Button from '@osui/button';
import 'antd/es/pagination/style';
import AntdPagination from './antd-pagination';
import './index.less';
var clsPrefix = 'osui-pagination';

var itemRender = function itemRender(current, type, originalElement) {
  if (type === 'prev') {
    return /*#__PURE__*/React.createElement(IconLeftOutlined, null);
  }

  if (type === 'next') {
    return /*#__PURE__*/React.createElement(IconRightOutlined, null);
  }

  return originalElement;
};

export var customPaginationProps = function customPaginationProps(brand) {
  var osc = {
    itemRender: itemRender,
    locale: {
      'jump_to': '去第',
      'page': '页'
    }
  };
  var icloud = {
    itemRender: itemRender,
    locale: {
      'jump_to': '跳转至',
      'page': ''
    }
  };
  return brand === 'osc' ? osc : icloud;
};

var toButtonSizeProps = function toButtonSizeProps(size) {
  if (size === 'default') {
    return 'middle';
  }

  return size;
};

var Pagination = function Pagination(props) {
  var _props$itemRender, _props$locale;

  var _useBrandContext = useBrandContext(),
      brand = _useBrandContext.brand;

  var innerShowQuickJumber = props.showQuickJumper;

  if (brand === 'icloud') {
    innerShowQuickJumber = {
      goButton: /*#__PURE__*/React.createElement(Button, {
        className: "".concat(clsPrefix, "-go-button"),
        size: toButtonSizeProps(props.size),
        disabled: props.disabled
      }, "Go")
    };
  }

  return /*#__PURE__*/React.createElement(AntdPagination, _objectSpread(_objectSpread({}, props), {}, {
    className: classNames(props.className, clsPrefix),
    itemRender: (_props$itemRender = props.itemRender) !== null && _props$itemRender !== void 0 ? _props$itemRender : customPaginationProps(brand).itemRender,
    locale: (_props$locale = props.locale) !== null && _props$locale !== void 0 ? _props$locale : customPaginationProps(brand).locale,
    showQuickJumper: innerShowQuickJumber
  }));
};

export default Pagination;
//# sourceMappingURL=index.js.map